/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { UserIdDto } from './UserIdDto';
import {
    UserIdDtoFromJSON,
    UserIdDtoFromJSONTyped,
    UserIdDtoToJSON,
} from './UserIdDto';

/**
 * 
 * @export
 * @interface ResetPasswordDto
 */
export interface ResetPasswordDto {
    /**
     * 
     * @type {string}
     * @memberof ResetPasswordDto
     */
    newPassword: string;
    /**
     * 
     * @type {boolean}
     * @memberof ResetPasswordDto
     */
    temporary: boolean;
    /**
     * 
     * @type {UserIdDto}
     * @memberof ResetPasswordDto
     */
    userId: UserIdDto;
}

/**
 * Check if a given object implements the ResetPasswordDto interface.
 */
export function instanceOfResetPasswordDto(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "newPassword" in value;
    isInstance = isInstance && "temporary" in value;
    isInstance = isInstance && "userId" in value;

    return isInstance;
}

export function ResetPasswordDtoFromJSON(json: any): ResetPasswordDto {
    return ResetPasswordDtoFromJSONTyped(json, false);
}

export function ResetPasswordDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): ResetPasswordDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'newPassword': json['newPassword'],
        'temporary': json['temporary'],
        'userId': UserIdDtoFromJSON(json['userId']),
    };
}

export function ResetPasswordDtoToJSON(value?: ResetPasswordDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'newPassword': value.newPassword,
        'temporary': value.temporary,
        'userId': UserIdDtoToJSON(value.userId),
    };
}

